import { render, staticRenderFns } from "./NotreApproche.vue?vue&type=template&id=3423ff18&scoped=true"
import script from "./NotreApproche.vue?vue&type=script&lang=js"
export * from "./NotreApproche.vue?vue&type=script&lang=js"
import style0 from "./NotreApproche.vue?vue&type=style&index=0&id=3423ff18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423ff18",
  null
  
)

export default component.exports